import { HttpClient } from '@angular/common/http';
import { ContextService } from './context.service';

export abstract class InteractionSyncService {
  private readonly baseUrlKey = 'InteractionSyncApiBaseUrl';

  constructor(
    protected readonly http: HttpClient,
    protected readonly context: ContextService,
  ) {}

  protected getUrl(path: string): string {
    if (!this.context.integration) {
      throw new Error('Integration not found');
    }

    if (!this.context.integration?.environment?.[this.baseUrlKey]) {
      throw new Error(
        `${this.baseUrlKey} not found in integration environment`,
      );
    }

    return `${this.context.integration.environment[this.baseUrlKey]}/${path}`;
  }
}
